import { Route } from "@angular/router";
import { MentionsLegalesComponent } from "./mentions-legales.component";

export const MentionsLegalesRouting: Route = {
  path: "mentions-legales",
  component: MentionsLegalesComponent,
  data: {
    breadcrumb: "Mentions Légales"
  }
};
